import BaseClass from './Base.class'

export default class OnDemandStatistics extends BaseClass {
  getJobsOfState (state) {
    return this.member.currentJobs.filter(x => x.state === state)
  }
}
